import 'react-app-polyfill/ie11';
import React from 'react';
import ReactDOM from 'react-dom';
import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import thunk from 'redux-thunk';

import App from './components/App';
import registerServiceWorker from './registerServiceWorker';
import authReducer from '@store/reducers/auth';
import quotingReducer from '@store/reducers/quoting';
import airportsReducer from '@store/reducers/airports';
import ImportImages from '@src/importImages';

import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import 'animate.css';

const Slider1 = ImportImages('/slider/bkg1.jpg');
const Slider2 = ImportImages('/slider/bkg2.jpg');
const Slider3 = ImportImages('/slider/bkg3.jpg');

const number = Math.floor(Math.random() * 100 + 1);
let sliderImg = null;
if (number < 33) {
  sliderImg = Slider1;
} else if (number < 66) {
  sliderImg = Slider2;
} else {
  sliderImg = Slider3;
}

const logger = store => {
  return next => {
    return action => {
      console.log('[Middleware] Dispatching', action);
      const result = next(action);
      console.log('[Middleware] next state', store.getState());
      return result;
    };
  };
};

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const appReducer = combineReducers({
  auth: authReducer,
  flightInfo: quotingReducer,
  airports: airportsReducer
});

const rootReducer = (state, action) => {
  if (action.type === 'AUTH_LOGOUT') {
    state = undefined;
  }

  return appReducer(state, action);
};
const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(logger, thunk))
);

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <App sliderImg={sliderImg} />
    </BrowserRouter>
  </Provider>,
  document.getElementById('root')
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js